<script setup>
import { ref } from "vue"
import NewBtn from "@/components/base/btn/NewBtn.vue";
import BarReceiptPrintModal from "@/components/orders/responsive/BarReceiptPrintModal.vue";
import LoadingModal from "@/components/Load/LoadingModal.vue";

const showBarReceiptPrint = ref(false)
const loadDetailsData = ref(null)


</script>

<template>
  <p>داشبورد</p>
</template>
